import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import AddResult from "../../Buttons/AddResult";
import Selected from "../../Inputs/Selected";
import Title from "../../Title/Title";

export default function Hall() {
  return (
    <>
      <Row>
        <Col lg={6} md={5}>
          <Title title=" القاعة الاولى " />
        </Col>
      </Row>
      <Row justify={"around"}>
        <Col lg={10} md={5}>
          <Selected title="القانون الجزئي">
            <option>AR</option>
            <option>EN</option>
            <option>FR</option>
          </Selected>
        </Col>
      </Row>
      <Row>
        <Col lg={11} md={4} className="mx-auto overflow-x-auto">
          <table className="w-full max-xl:!w-[1000px] bg-slate-100  max-lg:w-[850px] mx-auto my-5 text-center rounded-2xl overflow-hidden ">
            <thead className=" bg-[#efc5e6] text-black h-[70px] font-bold text-base">
              <tr>
                <td className="px-1">رقم الطالب</td>
                <td className="px-16"> اسم الطالب ونسبته</td>
                <td className="px-16"> اسم الاب</td>
                <td className="px-16"> اسم الام</td>
                <td className="px-16"> العلامة رقما</td>
                <td className="px-16"> العلامة كتابتا</td>
                <td className="px-16"> النتيجة</td>
                <td className="px-16">طباعة</td>
              </tr>
            </thead>

            <tbody className="h-[70px]">
              <tr className="border-2 border-white">
                <td>215</td>
                <td>محمد احمد</td>
                <td> احمد</td>
                <td> سعاد</td>
                <td> 100</td>
                <td> مئة</td>
                <td> 100</td>
                <td>
                  <button className="w-[100px] bg-[#efc5e6] p-2 rounded-2xl">
                    طباعة
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </Col>
      </Row>
      <AddResult />
    </>
  );
}
